<template>
  <div class="bottomNav">
    <confirm-modal
      v-if="showConfirmModal"
      :header="$t('menu.footer.confirm_cancel')"
      @onConfirm="abort"
      @onClose="turnConfirmModal"
    />
    <div v-if="showItem" class="cancelBtn big" @click="onClose">
      <span v-if="cancelIsStop" class="ResetFontSize">STOP</span>
      <span v-else>STOP</span>
    </div>
    <div v-else class="cancelBtn" @click="turnConfirmModal">
      <span v-if="cancelIsStop">STOP</span>
      <span v-else>{{ $t("menu.footer.cancel_order") }}</span>
    </div>
    <div class="itemWrapper" v-if="showItem">
      <div class="itemContainer">
        {{ toPrintable(productPrice(item)) }}
      </div>
    </div>
    <div
      class="totalContainer"
      :class="{ 'totalContainer-v2': isCustomHomeEnabled }"
      v-else-if="showTotalContainer"
      @click="goOrder"
    >
      <div class="total">
        <img class="shoppingbag" src="@/assets/img/icon_shoppingbag.png" />
        <div v-if="count > 0" class="count">
          {{ count }}
        </div>
      </div>
      <div :class="{ invisible: noprices }" class="totalPrice">
        {{ sumPrice }}
      </div>
    </div>
    <div class="spacer"></div>
    <div
      v-if="
        (site_setting.scan_and_go_enabled || site_setting.coupons_enabled) &&
          showScanAndGo
      "
      class="ScanAndGoButton"
      @click="$emit('showScanAndGoModal', $event)"
    >
      {{ $t(`order.btn.scanandgo`) }}
    </div>
    <div
      v-if="showSubmit"
      class="submit"
      @click="goOn"
      :class="{ disableSubmit: (!showItem && count === 0) || disableProceed }"
    >
      <slot></slot>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import { totalPrice, productPrice, toPrintable } from "@/utils/pricing";
import ConfirmModal from "@/components/modals/confirm.vue";
import { isEmpty } from "lodash";
import { cssVarBoolean, getTranslation } from "@/utils/helpers";
import { isCustomHomeEnabled } from "@/utils/templateSettings";

export default {
  components: {
    ConfirmModal
  },
  computed: {
    isCustomHomeEnabled,
    cancelIsStop() {
      return cssVarBoolean("--component_BottomNav_cancelbutton_is_stop");
    },
    sumPrice() {
      return totalPrice(this.basket, true, this.coupons);
    },
    count() {
      return this.basket.reduce((total, elem) => (total += elem.count), 0);
    },
    ...mapGetters({
      basket: "BASKET",
      coupons: "COUPONS",
      site_setting: "SITE_SETTING"
    }),
    showItem() {
      return !isEmpty(this.item);
    }
  },
  data() {
    return {
      showConfirmModal: false
    };
  },
  methods: {
    getTranslation,
    productPrice,
    toPrintable,
    turnConfirmModal() {
      this.showConfirmModal = !this.showConfirmModal;
    },
    abort() {
      this.setPolelight("green");
      this.clearBasket();
      this.logAudit({
        category: "PAGE",
        event: "CLOSE",
        data: "cancel"
      });
      this.logAudit({
        category: "ORDER",
        event: "CANCELLED",
        data: "cancel"
      });
      this.logRouter({ name: "home", router: this.$router });
    },
    goOn() {
      this.$emit("proceed");
    },
    goOrder() {
      this.$emit("goOrder");
    },
    onClose() {
      this.setPolelight("green");
      this.$emit("onClose");
    },
    ...mapMutations({
      clearBasket: "CLEAR_BASKET"
    }),
    ...mapActions({
      logRouter: "LOG_ROUTER",
      logAudit: "LOG_AUDIT",
      setPolelight: "SET_POLELIGHT"
    })
  },
  props: {
    item: Object,
    noprices: Boolean,
    disableProceed: Boolean,
    showTotalContainer: Boolean,
    showScanAndGo: Boolean,
    showSubmit: Boolean
  }
};
</script>
<style lang="scss" scoped>
.ResetFontSize {
  font-size: var(--component_BottomNav_button_font-size);
}

.invisible {
  opacity: 0;
}

.spacer {
  height: 134px;
  width: 200px;
}

.orderBtn {
  position: absolute;
  height: 134px;
  width: 527px;
  right: 0;
}

.bottomNav {
  position: relative;
  height: 134px;
  background: var(--component_BottomNav_bottomNav_background);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 40px;
}
.cancelBtn {
  letter-spacing: 1.36px;
  color: #f5f5f5;
  font-family: var(--component_BottomNav_button_font-family);
  font-size: var(--component_BottomNav_cancelBtn_font-size);
  width: 153px;
  height: var(--component_BottomNav_cancelBtn_height);
  background: var(--component_BottomNav_cancelbutton_background);
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  line-height: var(--component_BottomNav_cancelBtn_line-height);
  padding: var(--component_BottomNav_button_padding);
  text-transform: var(--component_BottomNav_cancelBtn_text-transform);
}

.cancelBtn.big {
  font-size: var(--component_BottomNav_cancelBtn_big_font-size);
}

.total {
  letter-spacing: 1.36px;
  color: var(--component_total_font_color);
  font-size: 17px;
  font-family: var(--component_BottomNav_total_font-family);
}
.totalPrice {
  font-family: var(--component_BottomNav_totalPrice_font-family);
  letter-spacing: var(--app_letter-spacing_dense);
  color: var(--component_total_font_color);
  font-size: var(--component_total_font_size);
  width: 167px;
  height: 66px;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  padding: 10px 0px 6px 7px;
}

.submit {
  font-size: var(--component_BottomNav_submitbutton_font-size);
  font-family: var(--component_BottomNav_button_font-family);
  letter-spacing: 1.8px;
  color: var(--component_BottomNav_submitbutton_color);
  background: var(--component_BottomNav_submitbutton_background);
  position: absolute;
  right: 40px;
  padding: var(--component_BottomNav_button_padding);
  height: var(--component_BottomNav_submitbutton_height);
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: var(--component_BottomNav_submitbutton_text-transform);
}
.disableSubmit {
  color: #ffffff;
  opacity: 0.35;
  background: rgb(255, 255, 255, 0.1);
}
.count {
  font-family: var(--component_BottomNav_count_font-family);
  height: 41px;
  width: 41px;
  border-radius: 50%;
  background: var(--component_BottomNav_count_background);
  box-shadow: 0px 3px 5px #00000029;
  font-size: 22px;
  color: var(--component_BottomNav_count_color);
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: -12px;
  left: 73px;
}
.totalContainer {
  position: absolute;
  left: 260px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 310px;
}
.totalContainer-v2 {
  left: 330px;
  .totalPrice {
    justify-content: flex-start;
    padding: 10px 0px 6px 0px;
  }
  .count {
    height: 50px;
    width: 50px;
    top: -6px;
    left: 70px;
  }
}
.itemContainer {
  font-family: var(--component_BottomNav_itemContainer_font-family);
  letter-spacing: 0.8px;
  color: var(--component_BottomNav_itemContainer_color);
  font-size: var(--component_BottomNav_itemContainer_font-size);
  width: 610px;
  height: 66px;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
}

.itemWrapper {
  position: absolute;
  left: 200px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 610px;
}

.ScanAndGoButton {
  background-color: var(--component_BottomNav_ScanAndGoButton_background-color);
  outline: var(--component_BottomNav_ScanAndGoButton_outline);
  letter-spacing: 1.36px;
  color: #f5f5f5;
  font-family: var(--component_BottomNav_button_font-family);
  font-size: var(--component_BottomNav_ScanAndGoButton_font-size);
  width: 370px;
  height: 64px;
  background-image: url("~@/assets/img/icon_scan.png");
  background-repeat: no-repeat;
  background-position: 12px -8px;
  display: flex;
  text-align: center;
  text-transform: var(--component_BottomNav_ScanAndGoButton_text-transform);
  align-items: center;
  justify-content: flex-start;
  padding: var(--component_BottomNav_ScanAndGoButton_padding);
}
.shoppingbag {
  content: var(--component_BottomNav_shopping_bag);
}
</style>
